// extracted by css-extract-rspack-plugin
export default {"hero":"HeroContentNext-module__hero__PHLT9","buttons":"HeroContentNext-module__buttons__pReBg"};